import { Redirect, Route, Switch } from 'react-router-dom';
import { VStack } from '@cbhq/cds-web/layout';

import { APIKeys } from ':cloud/pages/APIKeys';
import { ClientAPIKey } from ':cloud/pages/ClientAPIKey';
import { OAuth } from ':cloud/pages/OAuth';
import { AppRoute } from ':cloud/utils/routes';
import { APIKeyTitle } from ':cloud/widgets/access/api/APIKeyTitle';

export function APIKeyRouter() {
  return (
    <VStack width="100%">
      <APIKeyTitle />
      <Switch>
        <Route exact path={AppRoute.Projects.APIKeys}>
          <APIKeys />
        </Route>
        <Route exact path={AppRoute.Projects.ClientKey}>
          <ClientAPIKey />
        </Route>
        <Route exact path={AppRoute.Projects.KeysOAuth}>
          <OAuth />
        </Route>
        <Redirect to={AppRoute.Projects.APIKeys} />
      </Switch>
    </VStack>
  );
}
